import * as Yup from "yup";
import ESFragment from "./ESFragment";

export type ConfigType = {
  component: JSX.Element;
  schema: typeof schema;
  initialValues: SchemaType;
  keysToExclude?: Partial<keyof SchemaType>[];
};

export type SchemaType = Yup.InferType<typeof schema>;

const schema = Yup.object({
  workCountry: Yup.string().oneOf(["ES"]).required("Required"),
  probationPeriodDays: Yup.string()
    .required("Required")
    .oneOf(["0", "90"], "Must be none or 90 days."),
});

const CONFIG: ConfigType = {
  component: <ESFragment />,
  schema: schema,
  initialValues: {
    workCountry: "ES",
    probationPeriodDays: "0",
  },
  keysToExclude: [],
};

export default CONFIG;
